import React, { Component } from 'react';
import { values, filter } from 'lodash';

import ChartWaterBalance from './chart-water-balance/chart-water-balance.component'
import './wrapper-chart-water-balance.style.css';


export class WrapperChartWaterBalance extends Component {
    constructor(props) {
        super(props);
    }



    reorder = (sources, indexs) => {
        try {
            let temp = new Array(sources.length);

            // arr[i] should be present at index[i] index 
            for (let i = 0; i < sources.length; i++)
                temp[indexs[i]] = sources[i];

            // Copy temp[] to arr[] 
            for (let i = 0; i < sources.length; i++) {
                sources[i] = temp[i];
                indexs[i] = i;
            }
            return sources;

        } catch (error) {
            console.log('Error in reorder real loss:', error);
        }
    }

    createDataLeftChart = (dataNRWByDMA) => {
        try {
            let newObject = {};
            for (let key in dataNRWByDMA) {
                newObject[key] = key;
            }
            let arrayKey = values(newObject);
            // console.log('array v: ', arrayKey);

            let products = arrayKey.map((key) => {
                let oneObject = {}
                switch (key.toLowerCase()) {
                    case 'unauth_consump':
                        oneObject = { name: 'Unauthorised Consumption (Illegal)', value: dataNRWByDMA[key] }
                        break;
                    case 'cus_meter_inaccura':
                        oneObject = { name: 'Customer Metering Inaccuracies', value: dataNRWByDMA[key] }
                        break;
                    case 'app_losses':
                        oneObject = { name: 'APPARENT LOSSES (Commercial)', value: dataNRWByDMA[key] }
                        break;
                    case 'cur_an_real_loss':
                        oneObject = { name: 'CURRENT ANNUAL REAL LOSSES (CARL)', value: dataNRWByDMA[key] }
                        break;
                    default:
                        oneObject = { dmaid: `${key}`, name: false, percent: '', des_percent: '', value: `${dataNRWByDMA[key]}`, unit: '' }

                    // code block
                }
                return oneObject;
            });

            let optimizeProducts = filter(products, (o) => {
                return o.name
            });

            let indexs = [1, 2, 3, 0];

            let finalOutput = this.reorder(optimizeProducts, indexs);

            return finalOutput;
        } catch (error) {
            console.log('Error in create data left chart: ', error);
        }
    }

    createDataRightChart = (dataNRWByDMA) => {
        try {
            let newObject = {};
            for (let key in dataNRWByDMA) {
                newObject[key] = key;
            }
            let arrayKey = values(newObject);
            // console.log('array v: ', arrayKey);

            let products = arrayKey.map((key) => {
                let oneObject = {}
                switch (key.toLowerCase()) {
                    case 'bill_meter_consump':
                        oneObject = { name: 'Billed Metered Consumption', value: dataNRWByDMA[key] }
                        break;
                    case 'non_rev_water_nrw':
                        oneObject = { name: 'NON-REVENUE WATER (NRW)', value: dataNRWByDMA[key]}
                        break;
                    default:
                        oneObject = { dmaid: `${key}`, name: false, percent: '', des_percent: '', value: `${dataNRWByDMA[key]}`, unit: '' }

                    // code block
                }
                return oneObject;
            });

            let optimizeProducts = filter(products, (o) => {
                return o.name
            });

            let indexs = [0,1];

            let finalOutput = this.reorder(optimizeProducts, indexs);

            return finalOutput;
        } catch (error) {
            console.log('Error in create data right chart: ', error);
        }
    }

    render() {
        let dataLeftChart = this.createDataLeftChart(this.props.dataNRWByDMA);
        let dataRightChart = this.createDataRightChart(this.props.dataNRWByDMA);
        return (
            <div className="wrapper-chart-water-balance grid-container-chart-water-balance--fit">
                <div className="grid-element">
                    {/* <h1 className="name-element-dashboard">TOTAL LENGTH BY DMA</h1>
                    <h2 className="description-element-dashboard">June 2020</h2>
                    <ComposeChartTest></ComposeChartTest> */}
                    <ChartWaterBalance data={dataLeftChart}></ChartWaterBalance>
                </div>
                <div className="grid-chart-water-balance-element">
                    {/* <h1 className="name-element-dashboard">PERCENT NRW</h1>
                    <h2 className="description-element-dashboard">Per session</h2>
                    <LineChartTest></LineChartTest> */}
                    <ChartWaterBalance data={dataRightChart}></ChartWaterBalance>
                </div>
            </div>
        )
    }
}

export default WrapperChartWaterBalance
